import { objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

import type {
  GetDecisioningStudioAgentsAppGroupIdIdResult,
  PutDecisioningStudioAgentsAppGroupIdIdResult,
} from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdIdResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdIdResult>({
    id: string,
    of_client_slug: string,
    of_pipeline_slug: string,
    of_usecase_slug: string,
    frequency_cap: boolean,
    exclude_from_global_frequency_count: boolean,
  });

export const isPutDecisioningStudioAgentsAppGroupIdIdResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdIdResult>({
    id: string,
    of_client_slug: string,
    of_pipeline_slug: string,
    of_usecase_slug: string,
    frequency_cap: boolean,
    exclude_from_global_frequency_count: boolean,
  });
